import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import type { ProductMustTryCardProps } from 'Components/widgets/product-must-try-card/ProductMustTryCard';
import { ProductMustTryCard } from 'Components/widgets/product-must-try-card/ProductMustTryCard';
import { SliderHandler } from 'Components/frameworks/slider-handler/SliderHandler';
type Props = {
  className?: string;
  isFrench?: boolean;
  items: Array<ProductMustTryCardProps>;
  productIconName: IconName;
};
export const ProductMustTryLarge = ({
  className,
  isFrench,
  items = [],
  productIconName,
}: Props) => {
  const { isDesktop } = useResponsive();
  return (
    <div className={classnames('relative isolate -mx-20 overflow-hidden', className)}>
      <div className="absolute top-0 flex h-[390px] w-full justify-center overflow-hidden rounded-12 bg-lightSand p-20">
        <div
          className={classnames('relative px-60', {
            'pt-10': isFrench,
          })}
        >
          <div className="absolute start-0 top-0 opacity-25">
            <Icon className="text-sand" isNotSquare name={productIconName} width="8.75rem" />
          </div>
          <Icon
            className="text-black"
            name={isFrench ? ICONS.MUST_TRY_EXPERIENCES_FR : ICONS.MUST_TRY_EXPERIENCES}
            width={isFrench ? '11rem' : '10rem'}
          />
        </div>
      </div>
      <SliderHandler
        className="-mx-10"
        hasKeyboardSupport
        hasLazyload
        hasSwipeSupport
        items={items.map((item) => (
          <div className="relative h-full px-10" key={item.id}>
            <ProductMustTryCard {...item} />
          </div>
        ))}
        nbItemsToScroll={1}
        nbItemsToShow={isDesktop ? 4 : 3}
      >
        {({
          hasControls,
          isNextControlDisabled,
          isPreviousControlDisabled,
          itemsNode,
          onNext,
          onPrevious,
        }) => (
          <div className="relative mx-20 mt-95">
            {itemsNode}
            {hasControls && (
              <div className="pointer-events-none absolute inset-0 flex w-full items-center justify-between">
                {!isPreviousControlDisabled && (
                  <ArrowButton
                    className="pointer-events-auto -translate-x-1/2"
                    color={COLORS.WHITE}
                    label={t('common.previous')}
                    onClick={onPrevious}
                  />
                )}
                {!isNextControlDisabled && (
                  <ArrowButton
                    className="pointer-events-auto ms-auto translate-x-1/2"
                    color={COLORS.WHITE}
                    label={t('common.next')}
                    onClick={onNext}
                    rotation={180}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </SliderHandler>
    </div>
  );
};
